// 导入 抽取的 请求对象
import userRequest from '../utils/request';
import { getToken } from '../utils/token';
import { encrypt } from '@/utils/encryp';
const reFix = 'useradmin';
// const user = "user"
// 获取列表
export function getUserListApi(params) {
  return userRequest({
    url: reFix + '/Introduce',
    params: {
      ...params,
      ...{
        customerName: params.customerName ? encrypt(params.customerName) : '',
      },
    },
    headers: {
      houseId: JSON.parse(getToken('userInfo')).houseId,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 变更状态
export function changeStatusApi(url, data, isHeader = true) {
  let headers = isHeader
    ? { 'Content-Type': 'application/x-www-form-urlencoded' }
    : {};
  return userRequest({
    url: reFix + `/Introduce/${url}`,
    method: 'post',
    data,
    headers,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 人工分配
export function manualAllocationApi(url, data, isHeader = true) {
  let headers = isHeader
    ? { 'Content-Type': 'application/x-www-form-urlencoded' }
    : {};
  return userRequest({
    url: reFix + `/Introduce/${url}`,
    method: 'post',
    data: { ...data },
    headers,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 查询推荐记录
export function searchSignedApi(id) {
  return userRequest({
    url: reFix + '/Introduce/signed',
    params: {
      appRecordId: id,
    },
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 推荐失败记录
export function introduceFailRecordApi(params) {
  return userRequest({
    url: reFix + '/Introduce/introduceFailRecord',
    params,
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

//报备来源接口
export function introduceSourcedApi() {
  return userRequest({
    url: reFix + '/Introduce/introduceSource',
    method: 'post',
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// 修改客服
export function modifyCustomerService(data) {
  return userRequest({
    url: reFix + '/Introduce/customerService',
    data: { ...data },
    method: 'PUT',
  });
}

//1、统计邀请报表
export function getInvitateReportListApi(params) {
  return userRequest({
    url: reFix + '/Report/invitateReportList',
    method: 'GET',
    params,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}
// URL：/userAdmin/Report/invitateReportList
// 请求方式：Get  url拼接
// 请求参数:
// {
//   "areaId": "邀请人城市",
//   "userId": "邀请人id",
//   "startTime": "2022-09-10 09:41:32",//统计开始时间
//   "endTime": "2022-10-10 09:41:32",//统计结束时间
//   "pageIndex": 1,
//   "pageSize": 10,
//   "isExport": true
// }

//3、统计推荐报表
export function getIntroduceReportListApi(params) {
  return userRequest({
    url: reFix + '/Report/introduceReportList',
    method: 'GET',
    params,
    // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    // 跨域 是否携带 cookie
    withCredentials: true,
  });
}

// URL：/userAdmin/Report/introduceReportList
// 请求方式：Get  url拼接
// 请求参数:
// {
//   "areaId": "邀请人城市",
//   "userId": "邀请人id",
//   "houseId": "楼盘id",
//   "startTime": "2022-09-10 09:41:32",//统计开始时间
//   "endTime": "2022-10-10 09:41:32",//统计结束时间
//   "pageIndex": 1,
//   "pageSize": 10,
//   "isExport": true
// }
